export default "__VITE_ASSET__BluGQhA2__"